import type { Fetcher } from "react-query-kit";
import { createInfiniteQuery, createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../types";
import { getApi } from "../apiPath";
import { axiosClient } from "../clients";

import type { IFaculties } from "./routeType";

import { infiniteHelper } from "@utils";

const { key, getPath } = getApi("faculties.getAll");

type IExtractedRouteType = IFaculties["facultyCollectionRetrieve"];

export type IGetAllFaculties = IPickCollectionQuery<IExtractedRouteType>;

const getAllFaculties: Fetcher<
  IGetAllFaculties["response"],
  IGetAllFaculties["variables"],
  number
> = (params, { pageParam }) => {
  return axiosClient.get(getPath(), {
    params: { ...params, page: pageParam ?? params?.page },
  });
};

export const useGetAllFaculties = createQuery({
  queryKey: [key],
  fetcher: getAllFaculties,
});

export const useGetAllFacultiesInfinite = createInfiniteQuery({
  queryKey: [`infinite.${key}`],
  fetcher: getAllFaculties,
  ...infiniteHelper,
});
